export default __webpack_public_path__ + "static/media/telegram.a28e29d8.svg";